// 部门(组织机构)管理
import request from '@/router/axios';

let urlPrefix = '/api/system/dept';

/**
 * 根据id获取部门(组织机构)详情
 * @param {*} id
 */
export const getDept = (deptId,userId) => {
    return request(`${urlPrefix}/select/${deptId}/${userId}`)
}

/**
 * 获取对象
 * @param {number} id
 */
export const getDeptEntity = id => {
    return request(`${urlPrefix}/${id}`);
};

export const getDeptsList = (page, limit, params) => {
    return request(`${urlPrefix}/queryDeptList`, {
        params: {
            ...params,
            page,
            limit
        }
    })
}

// 获取部门基本信息
export const getDeptBrief = id => {
    return request(`${urlPrefix}/brief/${id}`).then(res => {
        return Promise.resolve({
            ...res,
        })
    }).catch(err => {
        return Promise.reject(err)
    })
}

/**
 * 获取部门树形菜单
 */
export const getDeptTree = () => {
    return request(`${urlPrefix}/select`);
};

/**
* 获取部门树形菜单(忽略token)
*/
export const getDeptListTree = () => {
   return request(`${urlPrefix}/register`);
};

/**
 * 关注
 */
export const attend = deptId => {
    return request(`${urlPrefix}/attend/${deptId}`, null, 'put');
};

/**
 * 取消关注
 */
export const cancel = deptId => {
    return request(`${urlPrefix}/cancel/${deptId}`, null, 'delete');
};

 /**
  * 查询我关注的机构
  * @param {*} page
  * @param {*} limit
  * @param {*} params
  * @returns
  */
export const getAttendList = (page, limit, params) => {
    return request(`${urlPrefix}/attendList`, {
        params: {
            ...params,
            page,
            limit
        }
    })
}

export const moveIndex = (deptId , type = 'down') => {
    return request(`${urlPrefix}/moveIndex/${deptId}/${type}`, {}, 'post')
}
